import React, { useState, useEffect } from "react";
import "./stylesPrematchStakeBreakdown.css";
import dayjs from "dayjs";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(value)}`;
        },
      },
    },
  },
};

const colors = ["#E74C3C", "#6177E8"];

function PrematchStakeBreakdown({ betTimingAnalysis, isApiRunning }) {
  const chartData = {
    labels: ["Pre-Match", "Live"],
    datasets: [
      {
        label: false,
        data: [betTimingAnalysis?.prematch_wager, betTimingAnalysis?.live_wager],
        backgroundColor: ["#E74C3C", "#6177E8"],
        borderColor: ["#E74C3C", "#6177E8"],
        borderWidth: 1,
      },
    ],
  };
  const labels = chartData?.labels; 

  return (
    <div className="prematch-stake-breakdown-container">
      <div className="prematch-stake-breakdown-header">
        <h2>Prematch vs. Live Stake breakdown</h2>
      </div>
      <div className="prematch-stake-breakdown-content">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="prematch-stake-breakdown-chart">
              <Pie data={chartData} options={options} />
            </div>
            <div className="prematch-stake-breakdown-legend">
              {labels.map((label, index) => (
                <div
                  className="prematch-stake-breakdown-legend-item"
                  key={index}
                >
                  <div
                    className="prematch-stake-breakdown-legend-item-color"
                    style={{ backgroundColor: colors[index] }}
                  />
                  <span className="prematch-stake-breakdown-legend-item-label">
                    {label}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default PrematchStakeBreakdown;
